import React,{useState} from "react"
import EditButton from "./EditButton";
import VideoEditor, { VIDEO_TYPE_EMBED } from "./VideoEditor";
import { useGlobal } from "./Reducer";
import Api from "./Api";
export default  (props)=>
{

    const [showEditor,setShowEditor]=useState(false);
    const [gs,ga] =useGlobal();
    if(gs.appData.video_file=="")
    {
        gs.appData.video_file=null;
    }
     
    if(gs.adminMode==false && gs.appData.video_file==null )
    {
        return null;
    }

    return (
    <div>
        {showEditor && <VideoEditor 
        
        
        onClose={()=>{
            setShowEditor(false);
        }} />}


    <div className="men-header row">
  Video     
</div>
<div className="whitebg boxed video_news row" id="video_contracted">





    <div className="col-md-6 col-sm-12 nopadding">
        <div style={{padding:5,backgroundColor:""}} id="video_here">
            { gs.appData.video_type!= VIDEO_TYPE_EMBED && <video
            onPlay={()=>{
                Api.recordAnalytics(gs.appData.id,"VIDEO_PLAY",gs.appData.video_title||'',gs.appData.video_file||'');
            }}
            controls={true} style={{maxWidth:260}} src={gs.appData.video_file||''}/>}
            {gs.appData.video_type == VIDEO_TYPE_EMBED &&<iframe 
            allowFullScreen={true} 
            
            width="100%"
            height={245}
             scrolling="no" frameBorder={0} 
             src={gs.appData.video_file||''}/>}
        </div>
    </div>
    <div className="col-md-6 col-sm-12">
        <div className="row">

            <div className="col" style={{paddingTop:5}}>
                <div className="video-detail-area faded_video">
                <div style={{fontWeight:"bold"}} className=" graytext text-center" id="vd_title">
                  {gs.appData.video_title||"Video Title"}
                </div>

                <div className="vid_desc  "  id="vd_desc">
                   {gs.appData.video_description||"Video Description"} 
                </div>
                <div className="subs_here "></div></div>
              

            </div>

        </div>
        <div
        
        style={{marginTop:-22,zIndex:5,position:"absolute",right:0,top:0}}
        
 className="centered changeable msgset" ref_tag="video_setter">
            <div className="globaleditbtn  hvr-shrink">
            <EditButton onClick={()=>setShowEditor(true)}/>
            </div>
        </div>
    </div>



</div>

 
</div>

);

}
